<main>
    <div *ngIf="!(afAuth.authState | async)">
        <!-- <h1>Login</h1>
        <button mat-raised-button appGoogleSignin>
            <img src="/assets/google-logo.svg"> Login with Google
        </button> 

        <h5>OR</h5> -->
        <app-login></app-login>
    </div>

    <div *ngIf="afAuth.authState | async as user" class="logout">
        <h1>Thank You for Registering!</h1>
        <img src="../../../assets/images/vectors/undraw_celebration_0jvk.png" width="800" height="500"
            alt="welcome image">
        <p>
            We will notify you as soon as our portal is live! In the meantime if you
            would like to
            contact us sooner feel free to schedule a session on <a
                href="https://calendly.com/malini/malinisengupta-rcic" target="_blank">Calendly.</a>
        </p>
        <button mat-raised-button (click)="afAuth.signOut()">Logout</button>
    </div>
</main>